namespace $.$$ {

	class Code_line extends $mol_text_code_line {
		minimal_height(): number {
			return 0
		}
	}

	export class $shm_hitalama_map_widget_float_text extends $.$shm_hitalama_map_widget_float_text {
		
		@ $mol_memo.field
		get $() {
			return super.$.$mol_ambient({
				$mol_text_code_line: Code_line,
			})
		}

		link_to_viewport_hint() {
			return '$'+"value('...')"
		}

		@ $mol_mem
		viewport_id( next?: string ): string {
			if( next === undefined ) {
				return this.widget().link_to_viewport()
			}
			return this.widget().link_to_viewport( next )
		}

		@ $mol_mem
		is_viewport_link(): boolean {
			return Boolean( this.viewport_id() )
		}

		@ $mol_mem
		textarea_height() {
			return this.textarea_auto_fit() ? 'auto' : super.textarea_height()
		}

		@ $mol_mem
		textarea_position() {
			return this.textarea_auto_fit() ? 'relative' : 'absolute'
		}

		@ $mol_mem
		textarea_auto_fit() {
			return this.widget().auto_height()
		}

		@ $mol_mem
		text( next?: string ): string {
			if( !this.editing() ) return this.text_rendered()
			return this.widget().text( next ) ?? ''
		}
		
		@ $mol_mem
		text_rendered() {
			return this.widget().preprocessed()
		}
		
		on_drag_start( event: PointerEvent ) {
			super.on_drag_start( event )
		}

		blocker_pointerdown_last?: PointerEvent
		blocker_pointerdown( next?: any ) {
			if( this.is_viewport_link() ) {

				const ref = this.viewport_id()?.slice( 8, -2 )
				this.Map_page().set_frame( ref )

			} else {
				this.blocker_pointerdown_last = this.selected() ? next : undefined
			}
		}
		blocker_pointerup( next?: any ) {
			if( !this.blocker_pointerdown_last ) return
			const { x, y } = this.blocker_pointerdown_last

			if( Math.abs( x - next.x ) < 5 && Math.abs( y - next.y ) < 5 ) {
				this.edit_start()
			}
		}

		content_double_click( event: PointerEvent ) {
			new $mol_after_frame(()=> this.edit_start())
		}

		edit_start() {
			this.Text().Edit().focused(true)
			;( this.Text().Edit().dom_node_actual() as HTMLTextAreaElement ).select()
		}

		@ $mol_mem
		editing(): boolean {
			if( this.text_focused() ) return true
			// if( this.selected() && this.text_focused() ) return true
			return false
		}

		@ $mol_mem
		blocker(): readonly ( any )[] {
			return this.editing() ? [] : super.blocker()
		}

		@ $mol_mem
		blocker_transform() {
			if( this.widget().auto_height() ) return ''
			return `translateY(${ this.Content_scroll().scroll_top() }px)`
		}

		@ $mol_mem
		blob_uri() {
			const blob = this.widget().Image()?.blob()
			if( !blob ) return null
			return this.$.$mol_blob_uri( blob )
		}

		@ $mol_mem
		image_uri(): string {
			this.widget().Image()?.blob()
			const uri = $mol_wire_sync(this).blob_uri()
			return uri ?? ''
		}

		@ $mol_mem
		image() {
			const uri = this.image_uri()
			return uri ? super.image() : []
		}

		@ $mol_mem
		ratio() {
			if( !this.image() ) return 0
			const img = this.Image()
			return img.natural_width() / img.natural_height()
		}
		

		@ $mol_mem
		font_size( next?: number ) {
			if( next !== undefined ) this.map().Last_font_size(null)?.val(next)
			
			return this.widget().Font_size(next)?.val(next) ?? 14
		}

		@ $mol_mem
		font_tools() {
			const text = this.widget().text() || ''
			return text === '' ? [] : super.font_tools()
		}

		@ $mol_mem
		font_size_px() {
			return this.font_size() + 'px'
		}

		@ $mol_mem
		color( next?: string ) {
			if( next === undefined ) return this.widget().Color()?.val() || 'var(--mol_theme_text)'

			this.map().Last_color(null)?.val(next)
			return this.widget().Color(null)?.val(next)!
		}
		
	}

}
